import type { ChatPublicEvent } from '../../../shared/types'

export const isChiliChatCustomEvent = (event: Event): event is CustomEvent<ChatPublicEvent> => {
  return 'detail' in event && 'action' in (event as any).detail
}
